import { PlusCircleOutlined } from "@ant-design/icons";
import {
  Card,
  Col,
  message,
  Row,
  Select,
  Form,
  Input,
  Typography,
  Button,
} from "antd";
import React from "react";
import { TypeIva } from "../../api/utils";
import { useProductStore } from "./LayoutProducto";

export const productStore = 1;
const { Option } = Select;

export const ProductSimple = ({ addProductSimple }) => {
  const producto = useProductStore();

  const onFinish = (values) => {
    console.log("::values", values);
    producto.setData({ productstore: productStore });
    addProductSimple(productStore);
  };

  const onFinishFailed = (errorInfo) => {
    message.info("Por favor complete todos los campos");
  };

  return (
    <Row
      justify="center"
      style={{ margin: "24px 0", width: "100%", maxWidth: "1000px" }}
    >
      <Col xs={24} sm={22} md={20} lg={18} xl={16}>
        <Card
          hoverable
          bordered={false}
          title={
            <Typography.Title level={4} style={{ margin: 0, color: "#1d1d1d" }}>
              Datos del Producto
            </Typography.Title>
          }
          style={{
            borderRadius: "16px",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
            backgroundColor: "#ffffff",
          }}
          bodyStyle={{ padding: "24px" }}
        >
          <Form
            layout="vertical"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            initialValues={{
              Codigo: producto.data.Codigo,
              IdCategoria: producto.data.IdCategoria,
              IdSubCategoria: producto.data.IdSubCategoria,
              Descripcion: producto.data.Descripcion,
              PrecioVentaConIva1: producto.data.PrecioVentaConIva1,
              PorcentajeIva: producto.data.PorcentajeIva,
              weight: producto.data.weight,
            }}
          >
            <Row gutter={24}>
              {/* Left Column */}
              <Col xs={24} md={12}>
                <Form.Item
                  label="Código Referencia"
                  name="Codigo"
                  rules={[{ required: false }]}
                >
                  <Input
                    size="large"
                    placeholder="Código de referencia del producto"
                    maxLength={45}
                    onChange={(value) =>
                      producto.setData({ Codigo: value.target.value })
                    }
                  />
                </Form.Item>

                <Form.Item
                  name="IdCategoria"
                  label="Categoría"
                  rules={[
                    { required: true, message: "Selecciona una categoría" },
                  ]}
                >
                  <Select
                    size="large"
                    placeholder="Selecciona una categoría"
                    onChange={(value) =>
                      producto.setData({
                        IdCategoria: value,
                        Categoria: producto.knowName(value, producto.categorys),
                      })
                    }
                    showSearch
                    optionFilterProp="children"
                  >
                    {producto.categorys.map((category) => (
                      <Option key={category.id} value={category.id}>
                        {category.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  label="Precio de venta"
                  name="PrecioVentaConIva1"
                  rules={[{ required: true, message: "Precio requerido" }]}
                >
                  <Input
                    size="large"
                    prefix="$"
                    type="number"
                    placeholder="200000"
                    onChange={(value) =>
                      producto.setData({
                        PrecioVentaConIva1: value.target.value,
                        PrecioVentaConIva2: value.target.value,
                        PrecioVentaConIva3: value.target.value,
                      })
                    }
                  />
                </Form.Item>
                <Form.Item
                  label="Peso del producto"
                  name="weight"
                  rules={[{ required: true, message: "Peso requerido" }]}
                >
                  <Input
                    size="large"
                    placeholder="Ej: 1 (kg), 300 (gr), 0.3 (otros)"
                    onChange={(value) =>
                      producto.setData({ weight: value.target.value })
                    }
                  />
                </Form.Item>
              </Col>

              {/* Right Column */}
              <Col xs={24} md={12}>
                <Form.Item
                  label="Nombre producto"
                  name="Descripcion"
                  rules={[
                    {
                      required: true,
                      message: "Nombre del producto requerido",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    placeholder="Nombre completo del producto"
                    onChange={(value) =>
                      producto.setData({ Descripcion: value.target.value })
                    }
                  />
                </Form.Item>
                <Form.Item
                  name="IdSubCategoria"
                  label="Subcategoría"
                  rules={[{ required: false }]}
                >
                  <Select
                    size="large"
                    placeholder="Selecciona una subcategoría (opcional)"
                    onChange={(value) =>
                      producto.setData({
                        IdSubCategoria: value,
                        SubCategoria: producto.knowName(
                          value,
                          producto.categorys
                        ),
                      })
                    }
                    showSearch
                    optionFilterProp="children"
                  >
                    {producto.categorys.map((category) => (
                      <Option key={category.id} value={category.id}>
                        {category.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="PorcentajeIva"
                  label="Porcentaje IVA"
                  rules={[{ required: true, message: "Selecciona un IVA" }]}
                >
                  <Select
                    size="large"
                    placeholder="Selecciona porcentaje IVA"
                    onChange={(value) =>
                      producto.setData({ PorcentajeIva: value })
                    }
                  >
                    {TypeIva.map((typeiva) => (
                      <Option key={typeiva.Codigo} value={typeiva.Valor}>
                        {typeiva.Descripcion}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Form.Item style={{ marginTop: "32px", textAlign: "center" }}>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                icon={<PlusCircleOutlined />}
                style={{
                  height: "48px",
                  width: "240px",
                  fontSize: "16px",
                  fontWeight: 500,
                  borderRadius: "12px",
                  boxShadow: "0 4px 12px rgba(24, 144, 255, 0.3)",
                  transition: "all 0.3s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow =
                    "0 6px 16px rgba(24, 144, 255, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 12px rgba(24, 144, 255, 0.3)";
                }}
              >
                Crear Producto
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Col>
    </Row>
  );
};
